import { SideNav } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { ManagerAuthorization } from '@common/enums';
import { getLanguage } from '@common/translate/translate';
import { hasOneAuthorization, useUiStateContext } from '@frontend/utils';

export interface IProfileNavigationProps {
    hasAccessToOldProfile: boolean;
    practitionerId: string;
}

export function ProfileNavigation(props: IProfileNavigationProps) {
    const { uiState, dispatchUiStateAction } = useUiStateContext();
    const translate = getLanguage();
    const practitionerId = useSelector((state: IReduxState) => state.authentication.id);
    const isPractitioner = practitionerId === props.practitionerId;

    return (
        <SideNav>
            <SideNav.Group
                defaultOpen={true}
                label={translate.common.profile}
                onClick={handleTopBarClick}
                to={`/practitioners/${props.practitionerId}/profile`}
                variant="link"
            >
                <SideNav.Link
                    label={translate.profile.security}
                    onClick={handleTopBarClick}
                    to={`/practitioners/${props.practitionerId}/profile/security`}
                    variant="link"
                />
                {(hasOneAuthorization(ManagerAuthorization.practitionerRead) || isPractitioner) && (
                    <SideNav.Link
                        label={translate.practitionerSso.singleSignOn}
                        onClick={handleTopBarClick}
                        to={`/practitioners/${props.practitionerId}/profile/sso`}
                        variant="link"
                    />
                )}
                {props.hasAccessToOldProfile && (
                    <SideNav.Link
                        label={translate.common.oldAdminPanel}
                        onClick={handleTopBarClick}
                        to={`/practitioners/${props.practitionerId}`}
                        variant="link"
                    />
                )}
            </SideNav.Group>
        </SideNav>
    );

    function handleTopBarClick() {
        if (uiState.isTopBarOpen) {
            dispatchUiStateAction({ isTopBarOpen: false, type: 'setIsTopBarOpen' });
        }
    }
}
